exports.parseServiceName = serviceName => {
  const serviceNameTrim = serviceName.trim()
  if (!!serviceNameTrim === false) {
    return ''
  }
  return decodeURIComponent(serviceNameTrim)
    .replace(/ \| /g, '-')
    .replace(/ \(|\(| & |&|'|’| |-/g, '-')
    .replace(/\)|\+|\/|\!/g, '')
    .replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/, '-')
    .toLowerCase()
}
